import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllJobTitles as apiDeleteAll } from "../../api/apiJobTitles";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllJobTitles() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: deleteAllJobTitles, isPending: isDelete } = useMutation({
        mutationFn: (req) => apiDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["jobTitles"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteAllJobTitles, isDelete };
}
